import { DialogDescription } from '@radix-ui/react-dialog';
import { DialogLoading, DialogLoadingContent, DialogLoadingTitle } from '../ui/dialog-loading';

export default function MasterpassLoadingDialog({
  open,
  content,
}: {
  open: boolean;
  content?: React.ReactNode;
}) {
  return (
    <DialogLoading open={open}>
      <DialogLoadingContent>
        <DialogLoadingTitle></DialogLoadingTitle>
        <DialogDescription className="h-0"></DialogDescription>
        {content}
      </DialogLoadingContent>
    </DialogLoading>
  );
}
